import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AbstractToolWrapper} from 'app/tool-layer/class/tool-wrapper';
import {ComponentModule} from 'app/component/component.module';
import {GeldComponent} from 'app/tool-layer/tools/geld/geld.component';

@NgModule({
    imports: [CommonModule, ComponentModule],
    declarations: [GeldComponent],
    providers: [
        {
            provide: AbstractToolWrapper,
            useValue: AbstractToolWrapper.create(GeldComponent),
            multi: true,
        },
    ],
})
export class GeldModule {}
